'use client'
import { usePathname } from 'next/navigation'
import Image from 'next/image'
import Link from 'next/link'

const squareAdUrl = 'https://media.travelm.de/travelm-bucket/a8aca7097c75d94744c3e18c53f48a68.webp'

const TravelSidebarAdSquareTop = ({ title }) => {
  const pathname = usePathname()
  if (pathname.includes('trending-article')) {
    return null
  }

  return (
    <div className="ad__row">
      <Link href="https://tui.com" target="_blank" rel="noopener noreferrer">
        <Image src={squareAdUrl} alt={title} width={400} height={400} />
      </Link>
      <p className="ad__text">{title}</p>
    </div>
  )
}

export default TravelSidebarAdSquareTop
